/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { CRMAccountVO } from '../crm-account-vo.model';
import { OpportunitySalesServiceVoModel } from './opportunity-sales-service-vo.model';
import { ServiceDtoModel } from '../service-dto.model';
import { CustomerSummaryVoModel } from '../customer/customer-summary-vo.model';

export class OpportunityDTO extends JSONable {
  uuid: string | undefined = undefined;
  opportunityName: string | undefined = undefined;
  opportunityType: string | undefined = undefined;
  pipelineStage: string | undefined = undefined;
  expectedCloseDate: string | undefined = undefined;
  businessRenewalDate: string | undefined = undefined;
  firstShipmentExpectedDate: string | undefined = undefined;
  reasonWonLost: string | undefined = undefined;
  leadSource: string | undefined = undefined;
  reasonForLead: string | undefined = undefined;
  probability: number | undefined = undefined;
  numberOfShipments: number | undefined = undefined;
  contractSigned: boolean | undefined = undefined;
  customerSummaryVO: CustomerSummaryVoModel | undefined = undefined;
  serviceDTO: ServiceDtoModel | undefined = undefined;
  services: OpportunitySalesServiceVoModel[] | undefined = undefined;
  accountVO: CRMAccountVO | undefined = undefined;

  competitors: string | undefined = undefined;

  fromJSON(json: any) {
    super.fromJSON?.(json);
    if (this.contractSigned === null) {
      this.contractSigned = false;
    }
  }
}
